module.exports = __webpack_public_path__ + "static/media/c26.3f121127.png";